require("es6-symbol/implement");
import AOS from "aos";
import "aos/dist/aos.css";
import anime from 'animejs';
import SmoothScroll from "smooth-scroll";
import accordion from './accordion';
import homeSlider from './homeslider';
import timelineSlider from './timelineslider';
import careersListing from './careers-listing';
import {debounce } from 'lodash';

AOS.init({
    duration: 600,
    ease: "ease-in-out",
    mirror: true,
    once: true,
});

function smoothScroll() {
    return new SmoothScroll('a[href*="#"]', {
        emitEvents: true, // Emit custom events
        topOnEmptyHash: false,
        header: "header.header",
    });
}

function headerScroll() {
    const header = document.querySelector(".header");
    window.addEventListener(
        "scroll",
        () => {
            if (window.scrollY >= 30) {
                header.classList.add("is-scrolled");
            } else {
                header.classList.remove("is-scrolled");
            }
        }, {
            passive: true,
        }
    );
}

function burgerClick() {
    const hb = document.querySelector(".tg-hamburger");
    hb &&
        hb.addEventListener("click", () => {
            document.body.classList.toggle("nav-open");
        });
}

function mobileNav() {
    const haveSub = [...document.querySelectorAll('.mobile-nav .has-sub')];
    haveSub.forEach(ni => {
        const link = ni.querySelector('.sub-link');
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const toggle = e.currentTarget.querySelector('.transform');

            if (toggle.classList.contains('rotate-45')) {
                ni.querySelector('.subcontainer').classList.add('max-h-0');
                toggle.classList.remove('rotate-45');
            } else {
                ni.querySelector('.subcontainer').classList.remove('max-h-0');
                toggle.classList.add('rotate-45');
            }

            return false;
        })
    })
}

function overviewToggle() {
    const buttons = [...document.querySelectorAll('[data-show]')];
    const sections = [...document.querySelectorAll('[data-show-target]')];

    buttons.forEach((button) => {
        const toShow = button.getAttribute('data-show');
        button.addEventListener('click', () => {

            sections.forEach(section => {
                if (section.getAttribute('data-show-target') == toShow) {
                    section.classList.remove('hidden');
                } else {
                    section.classList.add('hidden');
                }
            });

            buttons.forEach((btn) => {
                if (btn === button) {
                    btn.classList.remove('btn-outline--black');
                } else {
                    btn.classList.add('btn-outline--black');
                }
            })

        });
    })
}

function forms() {
    [...document.querySelectorAll('form select')].forEach(select => {
        select.addEventListener('change', ({ target }) => {
            if (target.options[0].value !== target.value) {
                target.classList.add('is-selected');
            } else {
                target.classList.remove('is-selected');
            }
        })
    });

    document.addEventListener( 'wpcf7mailsent', ({target}) => {
        const showOnSent = [...document.querySelectorAll('.show-on-sent')];
        showOnSent.forEach(el => {
            el.classList.add('is-shown');
        });

        const hideOnSent = [...document.querySelectorAll('.hide-on-sent')];
        hideOnSent.forEach(el => {
            el.classList.add('is-hidden');
        });


        const confirmation = target.nextElementSibling;

        if (confirmation) {
            confirmation.classList.remove('opacity-0');
            setTimeout(()=>{
                anime({
                    targets: confirmation.children,
                    opacity:[0, 1],
                    translateY: [20, 0],
                    delay: anime.stagger(120)
                });
            }, 500);
        } else {
            const defaultOutput = target.querySelector('.wpcf7-response-output');
            if (defaultOutput) {
                defaultOutput.classList.add('default-show');
            }
        }
    }, false );
}

document.addEventListener("DOMContentLoaded", () => {
    headerScroll();
    smoothScroll();
    homeSlider({
        speed: 6000
    });
    timelineSlider();
    accordion();
    burgerClick();
    mobileNav();
    overviewToggle();
    careersListing();
    forms();


    const hasSubs = [...document.querySelectorAll('header nav li')];

    const closeNav = debounce((el) => {
      el.classList.remove('is-open');
    }, 250);

    hasSubs.forEach((el)=>{
        el.addEventListener('mouseenter', ()=>{
            hasSubs.forEach(s => s.classList[s !== el ? 'remove': 'add']('is-open'))
        });
        el.addEventListener('mouseleave', ()=>{
            closeNav(el);
        });

    })
});